import React from 'react';
import './CalculatorPage.css'; 

// Importing necessary components
import { Calculator, PageTitle } from '../../../components';



const CalculatorPage = () => { 

  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={'Loan Calculator'} page={'Loan Calculator'} /> 

      {/* Loan Calculator Component */}
      <Calculator />

    </>
  );
}

export default CalculatorPage;